<template>
  <div v-if="product && template">
    <component :is="template" v-bind="templateProps" />
  </div>
</template>

<script>
  import PageCreateDefault from '@/components/templates/pages/default/create'

  export default {
    components: {
      PageCreateDefault
    },

    data () {
      return {
        template: null,
        product: null
      }
    },

    created () {
      this.getProduct()
    },

    methods: {
      getProduct () {
        this.$http.get(`products/${this.$route.params.sku}`)
          .then(resp => {
            this.product = resp.body
            if (!this.product.status) {
              this.product = null
              this.showErrorMessage('ไม่พบการบริจาค', true)
            } else {
              this.loadTemplate()
            }
          })
          .catch(err => {
            console.log(err)
            this.$modal.show({
              title: 'เกิดข้อผิดพลาด',
              text: 'ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
              okButtonText: 'ลองใหม่อีกครั้ง',
              ok: () => {
                window.location.reload()
              }
            })
          })
      },

      loadTemplate () {
        if (this.product.template) {
          try {
            this.template = require(`@/components/templates/pages/${this.product.template}/create`)
          } catch (err) {
            console.log(err)
            this.template = PageCreateDefault
          }
        } else {
          this.template = PageCreateDefault
        }
        this.templateProps = {
          product: this.product
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// CreatePagePage.vue?6732dd81